import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { StaticImage } from "gatsby-plugin-image"
import axios from "axios"

import { SectionHeader, MainWrapper, Spinner, OnClickButton } from "components"
import { ContactWrapper, ContactFormContent, FirstDiv } from "./styles"

export const ContactForm = () => {
  // button click
  const [loading, setLoading] = useState(false)
  // something went wrong
  const [message, setMessage] = useState("")

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm()

  // Form Submit
  const onSubmit = async ({ name, email, message }, e) => {
    setLoading(true)

    await axios
      .post("https://dm2msyt9n5.execute-api.us-east-1.amazonaws.com/final/", {
        name,
        email,
        message,
        destination: "iman.diaz@hungryhipposolutions.com",
      })
      .then(res => {
        setMessage("Thank you! We'll connect you soon!")
        e.target.reset()
      })
      .catch(err => setMessage("Something went wrong!"))

    setLoading(false)
  }
  return (
    <ContactWrapper id="contact">
      <MainWrapper>
        <SectionHeader padding="50px 0 10px 0" title="Contact Us" />
        <div
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
          className="cen"
        >
          <FirstDiv>
            <div
              data-sal="slide-up"
              data-sal-delay="350"
              data-sal-easing="ease"
            >
              <StaticImage
                src="../../images/locations.png"
                alt="Place"
                quality="100"
                placeholder="blurred"
                height={20}
              />

              <span
                data-sal="slide-up"
                data-sal-delay="350"
                data-sal-easing="ease"
              >
                {" "}
                730 N Victory Blvd, Burbank California 91502
              </span>
            </div>
            <div
              data-sal="slide-up"
              data-sal-delay="350"
              data-sal-easing="ease"
            >
              <StaticImage
                src="../../images/phone.png"
                alt="Place"
                quality="100"
                height={18}
                placeholder="blurred"
              />
              <a href="tel: 818-848-2325">
                <span
                  data-sal="slide-up"
                  data-sal-delay="350"
                  data-sal-easing="ease"
                >
                  {" "}
                  818-848-2325
                </span>
              </a>
            </div>
          </FirstDiv>

          <div
            className="make-cen"
            data-sal="slide-up"
            data-sal-delay="350"
            data-sal-easing="ease"
          >
            <StaticImage
              src="../../images/clock.png"
              alt="Place"
              quality="100"
              height={20}
              placeholder="blurred"
            />
            <h6> Opening Hours:</h6>
          </div>
          <ul className="hour">
            <li>Mon, Wed, Thur , Fri: 11 am - 9pm</li>
            <li>Tuesday : Closed</li>
            <li>Sat, Sun: 10:30 - 9 pm</li>
          </ul>
        </div>
        <ContactFormContent onSubmit={handleSubmit(onSubmit)}>
          <div
            data-sal="slide-up"
            data-sal-delay="350"
            data-sal-easing="ease"
            className="up-form"
          >
            <input
              placeholder="Full Name"
              {...register("name", { required: true, maxLength: 30 })}
            />
            {errors.fullName?.type === "required" && "Name is required!"}
            <input
              placeholder="Email"
              {...register("email", { required: true })}
            />
            {errors.email?.type === "required" && "Email is required!"}
          </div>

          <textarea
            rows="6"
            data-sal="slide-up"
            data-sal-delay="350"
            data-sal-easing="ease"
            placeholder="Message"
            {...register("message", { required: true })}
          />
          {errors.message?.type === "required" && "Message is required!"}

          {message ? <span>{message}</span> : ""}

          <div
            data-sal="slide-up"
            data-sal-delay="350"
            data-sal-easing="ease"
            className="submit"
          >
            <OnClickButton disabled={loading} type="submit">
              {loading ? <Spinner /> : "SEND YOUR MESSAGE"}
            </OnClickButton>
          </div>
        </ContactFormContent>
      </MainWrapper>
    </ContactWrapper>
  )
}
